export default __webpack_public_path__ + "static/media/turkey.6456288c.png";